import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "../Styles/work.css";

const ITEMS_PER_PAGE = 9;
const MIN_PAGES = 5;

const blogs = [
  { id: 5, image: "/assets/a_5.png", title: "Workplace Best Practices: Building a Culture That Drives Success", path: "/best-practices" },
  { id: 4, image: "/assets/a_4.png", title: "Outstanding Workplaces Launches HR Voices Event Series", path: "/hr-voices" },
  { id: 1, image: "/assets/a_1.png", title: "", path: "/novac-tech", badge: true },
  { id: 2, image: "/assets/a_2.png", title: "", path: "/aziro-tech", badge: true },
  { id: 3, image: "/assets/a_3.png", title: "When Good Hires Go Wrong: The Truth About Gut Decisions", path: "/good-hire" },
];

const categories = [
  { label: "All Blogs",                              path: "/blogs" },
  { label: "Workplace Best Practices",               path: "/work" },
  { label: "Employee Engagement",                    path: "/Engagement" },
  { label: "Employee Branding",                      path: "/Brand" },
  { label: "Thought Leadership & Workplace Culture", path: "/Thought" },
];

const getPageWindow = (current, total) => {
  const windowSize = 1;
  let start = Math.max(1, current - Math.floor(windowSize / 2));
  let end = start + windowSize - 1;
  if (end > total) {
    end = total;
    start = Math.max(1, end - windowSize + 1);
  }
  return Array.from({ length: end - start + 1 }, (_, i) => start + i);
};

const CustomDropdown = ({ selected, setSelected, onNavigate }) => {
  const [open, setOpen] = useState(false);

  return (
    <div className="work-dropdown">
      <div className="work-dropdown__header" onClick={() => setOpen(!open)}>
        <span>{selected}</span>
        <span className={`work-dropdown__arrow ${open ? "open" : ""}`}>
          <img src="/assets/arrow_1.png" alt="arrow" />
        </span>
      </div>

      {open && (
        <div className="work-dropdown__list">
          {categories.map((item, index) => (
            <div
              key={index}
              className="work-dropdown__item"
              onClick={() => {
                setSelected(item.label);
                setOpen(false);
                onNavigate(item.path);
              }}
            >
              {item.label}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

const BlogPage = () => {
  const navigate = useNavigate();
  const [selectedCategory, setSelectedCategory] = useState("Workplace Best Practices");
  const [currentPage, setCurrentPage] = useState(1);

  const realTotalPages = Math.ceil(blogs.length / ITEMS_PER_PAGE);
  const totalPages = Math.max(realTotalPages, MIN_PAGES);

  const handlePageChange = (n) => {
    if (n < 1 || n > totalPages) return;
    setCurrentPage(n);
  };

  const pageBlogs = blogs.slice(
    (currentPage - 1) * ITEMS_PER_PAGE,
    currentPage * ITEMS_PER_PAGE
  );

  const pageWindow = getPageWindow(currentPage, totalPages);

  return (
    <div className="work">
      {/* HEADER */}
      <div className="work__header">
        <h2 className="work__title-main">Workplace Best Practices</h2>
        <CustomDropdown
          selected={selectedCategory}
          setSelected={(label) => {
            setSelectedCategory(label);
            setCurrentPage(1);
          }}
          onNavigate={(path) => navigate(path)}
        />
      </div>

      {/* GRID */}
      <div className="work__grid">
        {pageBlogs.length > 0 ? (
          pageBlogs.map((blog) => (
            <div
              className="work-card"
              key={blog.id}
              onClick={() => blog.path && navigate(blog.path)}
            >
              <div className="work-card__image-wrapper">
                <img src={blog.image} alt="" className="work-card__image" />
                {blog.badge && (
                  <img
                    src="/assets/blog_badge.png"
                    alt="badge"
                    className="work-card__badge"
                  />
                )}
              </div>
              {blog.title && <p className="work-card__title">{blog.title}</p>}
            </div>
          ))
        ) : (
          <p className="work__no-results">No blogs found.</p>
        )}
      </div>

      {/* PAGINATION */}
      <div className="work-pagination">
        <button
          className="work-pagination__btn"
          onClick={() => handlePageChange(currentPage - 1)}
          disabled={currentPage === 1}
        >
          ← Previous
        </button>

        <div className="work-pagination__numbers">
          {pageWindow.map((n) => {
            const isDisabled = n > realTotalPages;
            return (
              <span
                key={n}
                className={`work-pagination__number 
                  ${n === currentPage ? "work-pagination__number--active" : ""}
                  ${isDisabled ? "work-pagination__number--disabled" : ""}
                `}
                onClick={() => !isDisabled && handlePageChange(n)}
              >
                {n}
              </span>
            );
          })}
        </div>

        <button
          className="work-pagination__btn"
          onClick={() => handlePageChange(currentPage + 1)}
          disabled={currentPage === realTotalPages}
        >
          Next →
        </button>
      </div>
    </div>
  );
};

export default BlogPage;